package org.example.project.enginetabular

fun toSemicolonCsvLine(values: List<String>): String =
    values.joinToString(";") { value ->
        "\"" + value.replace("\"", "\"\"") + "\""
    }

fun tabularCsvExportValue(value: String, isToggleColumn: Boolean): String {
    if (!isToggleColumn) return value
    return when (value.trim().lowercase()) {
        "\u2705", "\u2611", "ja", "true", "1" -> "Ja"
        "\u2b1c", "\u2610", "", "nein", "false", "0" -> "Nein"
        else -> value
    }
}

fun parseSemicolonCsv(content: String): List<List<String>> {
    val source = content.removePrefix("\uFEFF")
    val rows = mutableListOf<List<String>>()
    var row = mutableListOf<String>()
    val field = StringBuilder()
    var inQuotes = false
    var i = 0

    while (i < source.length) {
        val c = source[i]
        if (inQuotes) {
            if (c == '"') {
                if (i + 1 < source.length && source[i + 1] == '"') {
                    field.append('"')
                    i++
                } else {
                    inQuotes = false
                }
            } else {
                field.append(c)
            }
        } else {
            when (c) {
                '"' -> inQuotes = true
                ';' -> {
                    row.add(field.toString())
                    field.clear()
                }
                '\n' -> {
                    row.add(field.toString())
                    field.clear()
                    rows.add(row)
                    row = mutableListOf()
                }
                '\r' -> {
                    row.add(field.toString())
                    field.clear()
                    rows.add(row)
                    row = mutableListOf()
                    if (i + 1 < source.length && source[i + 1] == '\n') i++
                }
                else -> field.append(c)
            }
        }
        i++
    }

    if (field.isNotEmpty() || row.isNotEmpty()) {
        row.add(field.toString())
        rows.add(row)
    }

    return rows
}
